import { Text } from '@components/core/Typography'
import styled from 'styled-components'

export const StockErrorMessage = styled(Text)`
  color: ${({ theme }) => theme.colors.functional01};
  text-align: center;
`
